/* eslint-disable max-len */
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import HamburgerMenu from 'react-hamburger-menu';
import { openModal, toggleSpeech } from '../actions';
import logo from '../assets/navbar/logo.svg';
import Accessibility from './Accessibility';

class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  handleClick = () => {
    this.setState((prevState) => ({ open: !prevState.open }));
  }

  render() {
    return (
      <div className="nav-bar-container">
        <div className="nav-bar-left-side">
          <NavLink className="nav-link" to="/" onClick={() => this.setState({ open: false })}>
            <div className="nav-bar-logo-container">
              <img className="nav-logo" src={logo} alt="logo" />
              <p className="nav-header">MY BRAIN EXPLAINED</p>
            </div>
          </NavLink>
          <HamburgerMenu
            className="hamburger-menu"
            isOpen={this.state.open}
            menuClicked={this.handleClick}
            width={18}
            height={15}
            strokeWidth={1}
            rotate={0}
            color="black"
            borderRadius={0}
            animationDuration={0.5}
          />
        </div>
        <div className={`nav-links-container ${this.state.open ? '' : 'hide'}`}>
          <NavLink
            className="nav-link nav-link-text"
            activeClassName="active-nav-link-text"
            name="home"
            to="/"
            exact
            onClick={() => this.setState({ open: false })}
          >
            <p>Home</p>
          </NavLink>
          {this.props.auth ? (
            <NavLink
              className="nav-link nav-link-text"
              activeClassName="active-nav-link-text"
              name="dashboard"
              to="/dashboard"
              onClick={() => this.setState({ open: false })}
            >
              <p>Dashboard</p>
            </NavLink>
          ) : null}
          <NavLink
            className="nav-link nav-link-text"
            activeClassName="active-nav-link-text"
            name="about"
            to="/about"
            onClick={() => this.setState({ open: false })}
          >
            <p>About Us</p>
          </NavLink>
          <NavLink
            className="nav-link nav-link-text"
            activeClassName="active-nav-link-text"
            name="faq"
            to="/faq"
            onClick={() => this.setState({ open: false })}
          >
            <p>FAQ</p>
          </NavLink>
          {!this.props.auth ? (
            <div
              className="nav-link-sign-in"
              role="button"
              tabIndex="-1"
              onClick={() => {
                this.setState({ open: false });
                this.props.openModal('SignIn');
              }}
            >
              <p>Login or Sign Up</p>
            </div>
          ) : null}
          <Accessibility />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => (
  {
    toggle: state.modal.clicked,
    auth: state.user.authenticated,
  }
);

export default connect(mapStateToProps, { openModal, toggleSpeech })(NavBar);
